import { useCallback } from "react";
import { useRideStatuses as useRideStatusesBase } from "common-fe";
import { useScoreApi, unwrap } from "../api/scoreApi";

// score-api's batchRideStatus handler fans a Promise.all of per-ride sheet
// queries out inside ONE Lambda invocation (#544). A whole-show ride list
// (card #1243) can pass hundreds of ids in one call, which would balloon
// that fan-out past what a single request should carry. Chunk client-side at
// the same 100-id size score-api's own getManyById already uses for DynamoDB
// BatchGet (apps/score-api/src/handlers/ride.js), so no single request ever
// asks for more, then merge the chunk responses back into one array.
const STATUS_BATCH_SIZE = 100;

function chunk(items, size) {
  const out = [];
  for (let i = 0; i < items.length; i += size) out.push(items.slice(i, i + size));
  return out;
}

// scoreadmin wrapper around common-fe's useRideStatuses (#545): wires the
// score-api batch endpoint (#544) as the fetcher so every ride-status display in
// scoreadmin reads the SINGLE server-derived status — no client-side derivation
// (#546). Pass { intervalMs } to poll for realtime badges (#559).
export function useRideStatuses(rideIds, opts) {
  const scoreApi = useScoreApi();
  const fetchStatuses = useCallback(
    async (ids) => {
      const results = await Promise.all(
        chunk(ids, STATUS_BATCH_SIZE).map((c) =>
          scoreApi.rides.batchRideStatus({ rideIds: c }).then(unwrap),
        ),
      );
      return results.flat();
    },
    [scoreApi],
  );
  return useRideStatusesBase(rideIds, fetchStatuses, opts);
}

export default useRideStatuses;
